import Sidebar from "./Sidebar";

export { Sidebar as default };
